import { Material, MaterialProperties } from '../../core/Material';
import * as THREE from 'three';

export interface ToonMaterialProperties extends MaterialProperties {
  color: string;
  wireframe: boolean;
}

const properties: ToonMaterialProperties = {
  color: '#ffffff',
  wireframe: false,
};

export const ToonMaterialItem: Material = {
  id: '',
  name: 'Toon Material',
  type: 'material',
  subtype: 'toon',
  properties: properties,
  fields: [
    {
      key: 'properties.color',
      type: 'color',
      label: 'Color',
      default: '#ffffff',
      panel: 'material',
    },
    {
      key: 'properties.wireframe',
      type: 'boolean',
      label: 'Wireframe',
      default: false,
      panel: 'material',
    },
  ],
  render: (props) => {
    const { color, wireframe } = props;
    return new THREE.MeshToonMaterial({ color, wireframe });
  },
}; 